import { c as _c } from "react/compiler-runtime";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
import { Link } from 'react-router-dom';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const WelcomeBack = t0 => {
  const $ = _c(14);
  const {
    firstName,
    wishListProduct,
    onClose
  } = t0;
  const t1 = `Welcome back, ${firstName}`;
  const t2 = wishListProduct ? `The ${wishListProduct || "product"} has been` : "We missed you!";
  let t3;
  if ($[0] !== t2) {
    t3 = <span>{t2}{" "}</span>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = wishListProduct ? "/wishlist/" : "/customer/dashboard/";
  const t5 = wishListProduct ? "saved to your wishlist" : "Go to your dashboard";
  let t6;
  if ($[2] !== t5) {
    t6 = <CtaButton styling="link" color="brand" size="sm" hasArrow={true} block={true} noLinkPadding={true}>{t5}</CtaButton>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4 || $[5] !== t6) {
    t7 = <span className="[&_button]:p-0 [&_button]:ml-[5px]"><Link to={t4}>{t6}</Link></span>;
    $[4] = t4;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t3 || $[8] !== t7) {
    t8 = <>{t3}{t7}</>;
    $[7] = t3;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== onClose || $[11] !== t1 || $[12] !== t8) {
    t9 = <NotificationBannerSkeleton title={t1} body={t8} onClose={onClose} />;
    $[10] = onClose;
    $[11] = t1;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
WelcomeBack.propTypes = {
  firstName: PropTypes.string,
  wishListProduct: PropTypes.string,
  onClose: PropTypes.func
};
export default WelcomeBack;